import { useCallback } from 'react';
import { useCollectPaymentMultiContext } from '../../../../collect-payment-multi.context';
import { PAYMENT_MULTI_STEPS } from '../../../../utils/steps';
import { CareCreditMessageNavigationProps } from '../care-credit-message.types';

export const CareCreditMessageGenericNavigation = ({ body: Body }: CareCreditMessageNavigationProps) => {
  const {
    multiStep: { goPrevStep, onComplete },
  } = useCollectPaymentMultiContext();

  const onGoBack = useCallback(() => {
    goPrevStep({ orStep: PAYMENT_MULTI_STEPS.careCreditMessageDisclosure });
  }, []);

  const onCompleteStep = useCallback(() => {
    onComplete();
  }, [onComplete]);

  return <Body onGoBack={onGoBack} onCompleteStep={onCompleteStep} />;
};
